import { useTranslation } from '@mc/i18n'
import { Locations, PageSource } from '@mc/track-event'

import { useHPHeadingsExp } from 'experiments/pen-4680_v1_hp_title_subtitle'
import { Questions } from 'pages/index/components/HeroQuiz/components/WhatBringsYouVariantPALM/WhatBringsYouVariantPALM'
import { TooltipCta } from 'pages/index/components/HeroQuiz/components/TooltipCta'
import { trackPrimerAnswerSubmitted } from 'pages/index/components/HeroQuiz/events'
import { useWhatBringsYouVariantPALM } from 'pages/index/components/HeroQuiz/components/WhatBringsYouVariantPALM/useWhatBringsYouVariantPALM'
import { useCourseCategories } from './useCourseCategories'

export const Motivation = () => {
  const { t } = useTranslation('@mc/next')
  const courseCategories = useCourseCategories()

  const {
    sel,
    setSel,
    toggle,
    isSelected,
    selectedOptions,
    ctaHref,
    trackedCategoryNames,
    trackedCategoryIds,
    otherIsPreselected,
  } = useWhatBringsYouVariantPALM(courseCategories)

  const { firstQuizQuestionv2 } = useHPHeadingsExp() // pen-4680_v1

  return (
    <div className='col-12 col-lg-6 mc-py-lg-8 mc-px-lg-10 mc-py-xl-11 mc-px-xl-12'>
      <div className='d-none d-md-block mc-text-h5 mc-text-lg--center'>
        {firstQuizQuestionv2 || t('home.hero.quiz.title')}
      </div>
      <div className='d-md-none mc-text-body'>{t('home.hero.quiz.title')}</div>
      <div className='mc-my-7'>
        <Questions
          sel={sel}
          setSel={setSel}
          toggleCategory={toggle}
          isCategorySelected={isSelected}
          otherIsPreselected={otherIsPreselected}
          location={Locations.QUIZ_MODULE}
          pageSource={PageSource.CLASS_PAGE}
        />
      </div>
      <div className='d-flex flex-wrap mc-mb-4 mc-mb-md-0'>
        <TooltipCta
          disabled={selectedOptions.length === 0}
          href={ctaHref}
          action='Continue'
          onClick={() => {
            trackPrimerAnswerSubmitted({
              selectedOptions,
              selectedCategories: trackedCategoryNames,
              selectedCategoryIds: trackedCategoryIds,
              stepName: 'primer-question-modified',
              location: Locations.QUIZ_MODULE,
              pageSource: PageSource.CLASS_PAGE,
            })
          }}
          fullWidth
          location={Locations.QUIZ_MODULE}
          pageSource={PageSource.CLASS_PAGE}
        >
          {t('home.hero.cta.continue')}
        </TooltipCta>
      </div>
    </div>
  )
}
